import React from "react";
import { Configure } from "react-instantsearch";

export default function InstantSearchConfigure(props) {
	return <Configure {...props} />;
}
